import { MdRadioButtonChecked, MdRadioButtonUnchecked } from "react-icons/md";

interface BinaryRadioButtonsProps {
  title: string;
  options: string[];
  selectedOption: string;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
}

const BinaryRadioButtons: React.FC<BinaryRadioButtonsProps> = ({
  title,
  options,
  selectedOption,
  setSelectedOption,
}) => {
  return (
    <div className="self-stretch h-fit flex-col justify-start items-start gap-3 flex">
      <div className="rounded justify-start items-start gap-2 inline-flex">
        <div className="text-neutral-500 text-xs font-normal font-sans uppercase leading-[14px] tracking-wide">
          {title}
        </div>
      </div>
      <div className="w-fit h-fit flex-col justify-start items-start gap-2 flex">
        {options.map((option: string, index: number) => {
          return (
            <button
              key={index}
              className="group self-stretch rounded-lg justify-start items-center gap-3 inline-flex cursor-pointer"
              onClick={() => setSelectedOption(option)}
            >
              <div className="w-6 h-6 relative">
                {option === selectedOption ? (
                  <MdRadioButtonChecked className="w-full h-full fill-neutral-700 group-hover:fill-neutral-400" />
                ) : (
                  <MdRadioButtonUnchecked className="w-full h-full fill-neutral-700 group-hover:fill-neutral-400" />
                )}
              </div>
              <div className="grow shrink basis-0 h-fit py-1 justify-start items-center flex text-neutral-700 text-base font-normal font-sans leading-[19px]">
                {option}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BinaryRadioButtons;
